import {
    createRestClient,
    RestClient,
} from '@superbet-group/web.lib.rest';

import { RawHtmlPage } from '@app/rawHtmlPages/types';
import { defaultHttpTimeoutMs } from '@core/constants';
import {
    getCmsUrl,
    getCmsLocalePath,
} from '@core/services/cms/utils';
import store from '@app/store';
import {
    getConfig,
    IntroPageRetentionVisibility,
} from '@superbet-group/web.lib.config';

const restClient: RestClient = createRestClient(
    getCmsUrl({
        path: `/raw-html-pages/${getCmsLocalePath()}/`,
    }),
    defaultHttpTimeoutMs,
);

export function getRawHtmlPage(name: string): Promise<RawHtmlPage> {
    return restClient.get<RawHtmlPage>(name);
}

export async function getRawIntroPageName(): Promise<string> {
    const introPageConfig = getConfig().introPageSetup;
    const showRetention = await showRetentionPage(introPageConfig.retentionPageName, introPageConfig.retentionVisibilityLogic as IntroPageRetentionVisibility);
    return showRetention ? introPageConfig.retentionPageName as string : introPageConfig.acquisitionPageName as string;
}

async function showRetentionPage(retentionPageName: string | null | undefined, visibilityLogic: IntroPageRetentionVisibility): Promise<boolean> {
    if (retentionPageName) {
        switch (visibilityLogic) {
            case IntroPageRetentionVisibility.LoggedState:
                return !!await store.dispatch('data/authentication/isAuthenticated');
            case IntroPageRetentionVisibility.ReturningUserState:
                return !!store.getters['data/authentication/isReturningUserDevice'];
        }
    }
    return false;
}
